import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/vpn/many-networks-icon.svg")